<div [formGroup]="form" class="flex-wrap">

  <mat-form-field redispatchProvideReadonly>
    <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_WIRKLEISTUNG_AUSSPEICHERN_MAX"
    [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
    <mat-label>maximale Wirkleistung des Speichers zum Ausspeichern [kW]</mat-label>
    <input formControlName="wirkleistungAusspeichernMax"
      [redispatchDisableControl]="disabled || readonly"
      type="number"
      data-qa="wirkleistungAusspeichernMax"
      matInput
      name="batteriespeicher_wirkleistungAusspeichernMax"/>
    @if (f.wirkleistungAusspeichernMax.hasError('required')) {
      <mat-error>
        Bitte geben Sie eine Wirkleistung ein
      </mat-error>
    }
    @if (f.wirkleistungAusspeichernMax.hasError('max')) {
      <mat-error>
        Maximal 999999,999.
      </mat-error>
    }
    @if (f.wirkleistungAusspeichernMax.hasError('pattern') && !f.wirkleistungAusspeichernMax.hasError('max')) {
      <mat-error
        >
        Maximal 3 Nachkommastellen.
      </mat-error>
    }
  </mat-form-field>

  <mat-form-field redispatchProvideReadonly>
    <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_NUTZBARER_ENERGIEINHALT_SPEICHER"
    [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
    <mat-label>nutzbarer Energieinhalt des Speichers [kWh]</mat-label>
    <input formControlName="nutzbarerEnergieinhaltSpeichers"
      [redispatchDisableControl]="disabled || readonly"
      type="number"
      data-qa="nutzbarerEnergieinhaltSpeichers"
      matInput
      name="batteriespeicher_nutzbarerEnergieinhaltSpeichers"/>
    @if (f.nutzbarerEnergieinhaltSpeichers.hasError('required')) {
      <mat-error>
        Bitte geben Sie den nutzbaren Energieinhalt des Speichers [kWh] ein.
      </mat-error>
    }
    @if (f.nutzbarerEnergieinhaltSpeichers.hasError('max')) {
      <mat-error>
        Maximal 999999,999999.
      </mat-error>
    }
    @if (f.nutzbarerEnergieinhaltSpeichers.hasError('pattern') && !f.nutzbarerEnergieinhaltSpeichers.hasError('max')) {
      <mat-error
        >
        Maximal 6 Nachkommastellen.
      </mat-error>
    }
  </mat-form-field>

</div>
